import { Component } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './services/auth/auth.service';
import { UserService } from './services/user/user.service';
import { User } from './models/user-model';
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'studiomap-admin';

  user: any = null;
    location: any;
    routerSubscription: any;

    constructor(private router: Router, private authService: AuthService, private userService: UserService) {
    }

    ngOnInit() {

        if (this.authService.currentUserValue) {
            this.userService.get(this.authService.currentUserValue.token).subscribe(user => {
                let userJson = User.toJson(user, this.authService.currentUserValue.token);
                if (userJson != null) {
                    localStorage.setItem('studiomapAdmin', JSON.stringify(userJson));
                    this.authService.callCurrentUserSubject(userJson);
                } else {
                    this.authService.logout();
                }
            },err=>{
                this.authService.logout();
            });
        }
        this.recallJsFuntions();

    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }

}
